

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";



import bgImg from '../../assets/contactusBg.jpg'

import facebookImg from '../../assets/brand/facebook.png'
import youtubeImg from '../../assets/brand/youtube.png'
import instagramImg from '../../assets/brand/instagram.png'
import lineImg from '../../assets/brand/line.png'


import logoImg from '../../assets/logo.png'



import { separatorNumber, useGlobalFunc } from "../../global/constants.js";
import UserApi from "../../services/UserApi";
import { useSelector } from "react-redux";



const Home = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate()
    const query = new URLSearchParams(location.search);



    const { setLoading, successToast, errorToast } = useGlobalFunc()

    let linkList = [
        {
            link: "https://lin.ee/QicbUjW",
            img: lineImg,
        },
        {
            link: "https://www.facebook.com/profile.php?id=100093667357708",
            img: facebookImg,
        },
        {
            link: "https://www.youtube.com/channel/UCLNIP64iKNi1pxeSsmfsgSQ",
            img: youtubeImg,
        },
        {
            link: "https://www.instagram.com/alphamars.co/",
            img: instagramImg,
        },
    ]



    return <div className="relative bg-white " >


        <div className="relative mx-auto w-11/12 sm:w-full rounded-b-[40px] sm:rounded-b-none h-[300px] sm:h-screen overflow-hidden">
            <img className="w-full h-full object-cover" src={bgImg} />
            <img className=" absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-1/2 max-w-[80px] sm:max-w-[200px]  object-contain " src={logoImg} />
        </div >

        <div className=" w-full  session1 pt-[20px] pb-[80px] sm:pt-[100px] sm:pb-[150px] text-black96 ">

            <div>
                <p className="text-xl sm:text-3xl font-bold text-center mb-8">聯絡我們</p>
            </div>
            <div className="flex justify-center mb-14">
                <a className="mx-auto" href={"https://docs.google.com/forms/d/1aPEtMu5uuQ0TcXd2qHwKeQwkey8JIU0Wg-VUZ5JuFBM"} target="_blank" >
                    <button className="btn2 !py-1 !rounded-md" >{"馬上聯繫"}</button>
                </a>
            </div>

            <div className="mb-[20px] text-sm sm:text-lg ">
                <p className="text-lg sm:text-xl font-bold text-center ">前端星技股份有限公司</p>
                <div className="flex flex-col items-center text-center  mb-20 mx-auto">
                    <div>
                        <p>地址：臺北市南港區玉成街179號2樓之1</p>
                        <p>(鄰近後山埤捷運站3號出口)</p>
                        <p>電話：(02)5592-2006</p>
                        <p className="">統編：94050761</p>
                    </div>
                </div>

                <p className="text-lg sm:text-xl font-bold text-center mb-4">社群媒體</p>
                <div className="flex  gap-2 sm:gap-3 justify-center items-center">
                    {
                        linkList.map((i, index) => <a href={i.link} target="_blank"><div className={`bg-main1 w-12  aspect-[1/1] rounded-full ${index != 1 ? `p-[6px]` : 'pt-[2px] '}`}>
                            <img src={i.img} />
                        </div>
                        </a>)
                    }

                </div>

            </div>



        </div >



    </div >
}

export default Home